import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { AddToCart } from "./AddToCart";
import type { LineItemMember } from "./LineItemMember";
import type { LineItemRef } from "./LineItemRef";
import type { OrderAmountsBase } from "./OrderAmountsBase";
import type { OrderDTOBase } from "./OrderDTOBase";
import type { OrderLineDetail } from "./OrderLineDetail";
import type { OrderPaymentRef } from "./OrderPaymentRef";
import type { OrderSource } from "./OrderSource";
import type { OrderStatus } from "./OrderStatus";
import type { PaymentAttempt } from "./PaymentAttempt";
import type { StartPayment } from "./StartPayment";
import type { TrackedModernBase } from "./TrackedModernBase";

export class OrderMember implements OrderDTOBase, TrackedModernBase, OrderAmountsBase {
  constructor(public readonly assignId: number, public readonly orderStatus: OrderStatus | null, public readonly orderSource: OrderSource | null, public readonly orderUserId: number | null, public readonly amountPaidCents: number | null, public readonly settlementFundingForId: number | null, public readonly amountRefundedCents: number | null, public readonly amountCapturableCents: number | null, public readonly squareOrderId: string | null, public readonly version: number | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly amountSubtotalCents: number | null, public readonly amountDiscountsCents: number | null, public readonly amountTaxesCents: number | null, public readonly amountTotalCents: number | null, public readonly lineItems: Array<LineItemMember> | null) {
    this.cbiServiceContext = null;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  async addToCart(request: AddToCart): Promise<LineItemRef> {
    return await this.cbiServiceContext!.orderService().addToCartMember({ order: { assignId: this.assignId }, request: request });
  }
  async applyDiscountFromCode(code: string): Promise<void> {
    return await this.cbiServiceContext!.orderService().applyDiscountFromCodeMember({ order: { assignId: this.assignId }, code: code });
  }
  async cancel(): Promise<void> {
    return await this.cbiServiceContext!.orderService().cancelMember({ assignId: this.assignId });
  }
  async orderLineDetails(): Promise<Array<OrderLineDetail>> {
    return await this.cbiServiceContext!.orderService().orderLineDetailsMember({ assignId: this.assignId });
  }
  async pay(): Promise<void> {
    return await this.cbiServiceContext!.orderService().payMember({ assignId: this.assignId });
  }
  async reopen(): Promise<void> {
    return await this.cbiServiceContext!.orderService().reopenMember({ assignId: this.assignId });
  }
  async completePayment(): Promise<void> {
    return await this.cbiServiceContext!.paymentService().completePaymentMember({ assignId: this.assignId });
  }
  async paymentAttempts(): Promise<Array<PaymentAttempt>> {
    return await this.cbiServiceContext!.paymentService().paymentAttemptsMember({ assignId: this.assignId });
  }
  async startPayment(request: StartPayment): Promise<OrderPaymentRef> {
    return await this.cbiServiceContext!.paymentService().startPaymentMember({ order: { assignId: this.assignId }, request: request });
  }
}
